import {memo, RefObject, useCallback, useState} from 'react';
import {InputAction} from '../../atoms/input-action';
import {InFormButton} from '../../atoms/in-form-button';

export interface PasswordInputToggleProps {
  inputRef: RefObject<HTMLInputElement>;
}

export const PasswordInputToggle = memo(function ({
  inputRef,
}: PasswordInputToggleProps) {
  const [visible, setVisible] = useState(inputRef.current?.type === 'password');

  const onClick = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.setAttribute(
        'type',
        inputRef.current.type === 'password' ? 'text' : 'password',
      );
      setVisible(!visible);
    }
  }, [inputRef, visible]);

  return (
    <InputAction
      children={
        visible ? (
          <InFormButton>Hide</InFormButton>
        ) : (
          <InFormButton>Show</InFormButton>
        )
      }
      kind="textBody"
      onClick={onClick}
    />
  );
});

PasswordInputToggle.displayName = 'PasswordInputToggle';
